import routes from './router'
import Router from 'vue-router'
import {post} from './api/index'
import {formatRoutes,loadView} from './utils/index'
const createRouter = () => new Router({
  routes,
})
let isMenus = false;
const router = createRouter();
router.beforeEach(async(to, from, next) => {
  window.scrollTo(0,0)
  next();
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js